module.exports = __webpack_public_path__ + "images/this-is-money.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/this-is-money.png
// module id = 851
// module chunks = 1